import React from "react";
// import tick from "../tick-white.png";

function CampaignView(props) {
  const { campaign, setCampaign, setProduct, tapes, ads } = props;
  const camp = ads.filter((el) => el.campaignId === campaign);

  return (
    <div>
      <button
        className="back-button"
        onClick={() => {
          setCampaign(undefined);
        }}
      >
        Takaisin Kampanjalistaan
      </button>
      <br />
      <h2 className="campaign-title">
        {camp[0].client /*+ " viikko " + campaign[0].start*/}
      </h2>
      {camp.reduce((pre, cur, index, array) => {
        const reduce = tapes.reduce(
          (pre2, cur2) => {
            if (
              cur.campaignId === cur2.campaignId &&
              cur.format === cur2.format
            ) {
              pre2.sum = pre2.sum + Number(cur2.amount);
            }
            if (
              cur.campaignId === cur2.campaignId &&
              cur.format === cur2.format &&
              cur2.removed !== "X"
            ) {
              pre2.taped = pre2.taped + Number(cur2.amount);
            }
            return pre2;
          },
          { sum: 0, taped: 0 }
        );
        const name =
          (cur.ready === "X" ? "\u2714 " : "") +
          cur.format +
          " viikot " +
          cur.start +
          " - " +
          cur.end +
          "  |  " +
          reduce.taped +
          " / " +
          reduce.sum +
          " / " +
          cur.amount;
        pre.push(
          <div
            className="campaign-product"
            key={index}
            onClick={() => {
              setProduct(cur.index);
              window.history.pushState(
                { role: "teippaus", campaign, product: cur.index },
                "Product: " + cur.index,
                "?product=" + cur.index
              );
            }}
          >
            {name}
            <div className={"infoContainer"}>
              {cur.info && cur.info.length ? "Lisätiedot: " + cur.info : ""}
            </div>
          </div>
        );

        return pre;
      }, [])}
    </div>
  );
}

export default CampaignView;
